import QuizIcon from '@material-ui/icons/FormatListNumbered';
import QuizReportsList from './components/QuizReportsList';
import { APP_TYPES, roles } from '../../../config/constants';

const options = {
  appTypes: [APP_TYPES.ALL],
  allowedRoles: [roles.ADMIN, roles.JTI_TEAM],
  label: 'Quiz',
  subMenuName: 'reports',
};

export default {
  list: QuizReportsList,
  icon: QuizIcon,
  name: 'admin/reports/quizzes',
  options,
};
